/**
 * Sidebar palette for the Workflow Builder.
 * Lists available node types that can be dragged onto the canvas.
 */
import React from 'react';

const NODE_TYPES = [
    {
        type: 'doqsolv',
        label: 'Document Generation',
        description: 'Generate PDF from template',
        color: '#6366F1',
        bgColor: 'rgba(99, 102, 241, 0.1)',
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
        ),
    },
    {
        type: 'live_stamping',
        label: 'Live Stamping',
        description: 'Procure stamp paper',
        color: '#10B981',
        bgColor: 'rgba(16, 185, 129, 0.1)',
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
        ),
    },
    {
        type: 'esign',
        label: 'eSign',
        description: 'Send for e-signature',
        color: '#3B82F6',
        bgColor: 'rgba(59, 130, 246, 0.1)',
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
        ),
    },
];

const Sidebar = () => {
    const onDragStart = (event, nodeType) => {
        event.dataTransfer.setData('application/reactflow', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div
            style={{
                width: '240px',
                background: '#1E293B',
                borderRight: '1px solid rgba(255,255,255,0.06)',
                display: 'flex',
                flexDirection: 'column',
                flexShrink: 0,
            }}
        >
            {/* Header */}
            <div style={{ padding: '16px 16px 12px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <h3 style={{ color: '#F1F5F9', fontSize: '13px', fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase', margin: 0 }}>
                    Service Nodes
                </h3>
                <p style={{ color: '#94A3B8', fontSize: '11px', marginTop: '4px' }}>
                    Drag onto the canvas
                </p>
            </div>

            {/* Node List */}
            <div style={{ padding: '12px', display: 'flex', flexDirection: 'column', gap: '8px', flex: 1, overflowY: 'auto' }}>
                {NODE_TYPES.map((node) => (
                    <div
                        key={node.type}
                        draggable
                        onDragStart={(e) => onDragStart(e, node.type)}
                        style={{
                            padding: '12px',
                            borderRadius: '10px',
                            background: node.bgColor,
                            border: `1px solid ${node.color}33`,
                            cursor: 'grab',
                            transition: 'all 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-1px)';
                            e.currentTarget.style.boxShadow = `0 4px 12px ${node.color}22`;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        <div
                            style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '8px',
                                background: node.color,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                flexShrink: 0,
                            }}
                        >
                            {node.icon}
                        </div>
                        <div>
                            <div style={{ color: '#F1F5F9', fontSize: '13px', fontWeight: 600 }}>
                                {node.label}
                            </div>
                            <div style={{ color: '#94A3B8', fontSize: '11px', marginTop: '2px' }}>
                                {node.description}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Sidebar;
